import { useParams, useSearchParams } from 'react-router-dom';
import { PageHeader } from '@billda/design-system';
import { usePlatformOrganisation } from '../hooks/usePlatformOrganisation';
import { OrgOverviewTab } from '../components/organisms/OrgOverviewTab';
import { OrgFeaturesTab } from '../components/organisms/OrgFeaturesTab';
import { PageBreadcrumb } from '../../../shared/components/layout/PageBreadcrumb';
import { ChipTabs } from '../../../shared/components/ui/ChipTabs';
import { Routes } from '../../../routes';

const DETAIL_TABS = [
  { label: 'Overview', value: 'overview' },
  { label: 'Features', value: 'features' },
] as const;

const PlatformOrganisationDetailPage = () => {
  const { orgId } = useParams<{ orgId: string }>();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') === 'features' ? 'features' : 'overview';

  const { data } = usePlatformOrganisation(orgId ?? '');
  const organisationName = data?.name ?? '';

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="min-h-0 flex-1 overflow-auto">
        <div className="px-4 pt-4 pb-2 sm:px-6">
          <PageBreadcrumb
            segments={[
              { label: 'Organisations', to: Routes.platform.organisations },
              { label: organisationName },
            ]}
          />
        </div>

        <PageHeader title={organisationName} />

        <div className="px-4 pb-2 sm:px-6">
          <ChipTabs
            tabs={[...DETAIL_TABS]}
            value={tab}
            onChange={v => setSearchParams({ tab: v }, { replace: true })}
            data-testid="org-detail-tabs"
          />
        </div>

        {tab === 'features' ? (
          <OrgFeaturesTab orgId={orgId ?? ''} />
        ) : (
          <OrgOverviewTab orgId={orgId ?? ''} />
        )}
      </div>
    </div>
  );
};

export default PlatformOrganisationDetailPage;
